export default {
  // language=HTML (for PhpStorm)
  template: `
    <ui-form-partial label="Business" class="is-business-partial">
      <ui-form-item label="Business Name" prop="business.name">
        <ui-form-input name="app_business_name" v-model="model.business.name" input-class="width--medium" />
      </ui-form-item>

      <br>
      <ui-form-address
        address-label="Service Address"
        name-prefix="app_servadd_"
        prop-prefix="business.serviceAddress"
        :address="model.business.serviceAddress" />

      <ui-form-item label="Federal ID# or Social Security Number" prop="business.federalId">
        <ui-form-input name="business_id" v-model="model.business.federalId" input-class="width--small" />
      </ui-form-item>
    </ui-form-partial>
  `,

  props: {
    model: Object,
  },
}
